import { useEffect, useState, useRef } from "react";
import cn from "clsx";
import styles from "../reviews.module.scss";
import { Box, Tab, Tabs } from '@mui/material';

type Props = {
  activeIndex: number;
  navList: string[];
  targetClassName?: string;
  onChange?: (index: number) => void;
};

export default function TabNav({ navList, onChange, activeIndex }: Props) {
  // const [indexActive, setIndexActive] = useState<number>(0);

  const onNavClick = (index: number) => {
    onChange?.(index);
  };

  useEffect(() => {}, []);

  return (
    <div className={styles.review_tab_nav}>
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '0.5px',
            backgroundColor: '#C2C4CC',
          }}
        />
        <Tabs
          value={activeIndex}
          onChange={(e, tab) => onNavClick(tab)}
          textColor='inherit'
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#000',
            },
          }}
        >
          {navList.map((nav: string, index: number) => {
            return (
              <Tab
                label={nav}
                key={index}
                value={index}
                sx={{
                  fontSize: 16,
                  textTransform: 'none',
                  fontWeight: 700,
                  px: 0,
                  minWidth: 'auto',
                  mr: 4,
                  '&:last-child': {
                    mr: 0,
                  },
                }}
                disableRipple
              />
            );
          })}
        </Tabs>
      </Box>
    </div>
  );
}
